import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { Icon } from '@ui/themed';

/**
 * A platform tinted tile wrapping a single icon
 */
export function FeatureIconTile({ icon }: { icon: IconName }) {
  return (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-black/15 bg-platform-primary/10 text-platform-primary">
      <Icon name={icon} size="md" />
    </span>
  );
}
